<template>
  <div>
    <div class="yesnoQuestion">
      <p>Does the farmer have any Crop Insurance?</p>
      <div class="checkbox-div">
        <div class="check" @click="handleClick('crops', true)">
          <input type="checkbox" :checked="insurance.crops" :value="true" />
          <p>Yes</p>
        </div>
        <div class="check" @click="handleClick('crops', false)">
          <input
            type="checkbox"
            :checked="insurance.crops == false"
            :value="false"
          />
          <p>No</p>
        </div>
      </div>
    </div>

    <div class="yesnoQuestion">
      <p>Does the farmer have any Tractor Insurance?</p>
      <div class="checkbox-div">
        <div class="check" @click="handleClick('tractor', true)">
          <input type="checkbox" :checked="insurance.tractor" :value="true" />
          <p>Yes</p>
        </div>
        <div class="check" @click="handleClick('tractor', false)">
          <input
            type="checkbox"
            :checked="insurance.tractor == false"
            :value="false"
          />
          <p>No</p>
        </div>
      </div>
    </div>

    <div class="yesnoQuestion">
      <p>Does the farmer have any Health Insurance?</p>
      <div class="checkbox-div">
        <div class="check" @click="handleClick('health', true)">
          <input type="checkbox" :checked="insurance.health" :value="true" />
          <p>Yes</p>
        </div>
        <div class="check" @click="handleClick('health', false)">
          <input
            type="checkbox"
            :checked="insurance.health == false"
            :value="false"
          />
          <p>No</p>
        </div>
      </div>
    </div>

    <div class="yesnoQuestion">
      <p>Does the farmer have any Other Insurance?</p>
      <div class="checkbox-div">
        <div class="check" @click="handleClick('others', true)">
          <input type="checkbox" :checked="insurance.others" :value="true" />
          <p>Yes</p>
        </div>
        <div class="check" @click="handleClick('others', false)">
          <input
            type="checkbox"
            :checked="insurance.others == false"
            :value="false"
          />
          <p>No</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import multipleAnswers from "./multiple-answer.vue";

export default {
  name: "insuranceTab",
  components: {},
  props: {
    heading: String,
    showYesNo: Boolean,
    showDropdownQuestion: Boolean,
  },
  data() {
    return {
      insurance: {
        health: null,
        tractor: null,
        others: null,
        crops: null,
      },
    };
  },
  created() {
    const data = this.$store.getters["crmFilters/GET_INSURANCE_DATA"];
    //   if(data.tractor)
    //   this.insurance.tractor=data.tractor
  },
  methods: {
    handleClick(type, value) {
      console.log(type, value);
      switch (type) {
        case "tractor":
          this.insurance.tractor =
            this.insurance.tractor == value ? null : value;
          break;
        case "others":
          this.insurance.others = this.insurance.others == value ? null : value;
          break;
        case "health":
          this.insurance.health = this.insurance.health == value ? null : value;
          break;
        case "crops":
          this.insurance.crops = this.insurance.crops == value ? null : value;
          break;

        default:
          break;
      }

      console.log(this.insurance);
      this.$store.dispatch("crmFilters/setInsurance", {
        health: this.insurance.health,
        tractor: this.insurance.tractor,
        others: this.insurance.others,
        crops: this.insurance.crops,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.question-tab {
  height: 51px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  gap: 16px;
  margin-left: 2px;
  width: 100%;
  p {
    margin: 0;
  }
}
.yesnoQuestion {
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-left: 28px;
  width: 100%;
  p {
    margin: 0;
  }
}
.checkbox-div {
  display: flex;
  align-items: center;
  width: 40%;
  gap: 32px;

  .check {
    display: flex;
    align-items: center;
    gap: 12px;
    p {
      color: #4b4b4b;
    }
  }
}
input[type="checkbox"] {
  accent-color: #189d3b;
  height: 16px;
  width: 16px;
  border-radius: 4px;
}
</style>
